


































































































































































































































import { Vue, Watch, Component } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';


interface Obl {
    code: string; 
    obl: string; 
    region: string;
}

interface District {
    code: string; 
    name: string;
}

interface Year {
  id: number;
  year: number; 
}

interface Direction {
    code: string; 
    name: string; 
}


@Component({
    components: {
        'multiselect': Multiselect
    }
})
export default class SrsReport extends Vue {
    $refs!: {
        drop: any;
        year: any;
        district: any;
    };


    obl: Obl = {code: '', obl: '', region: ''};
    moduleCode = '003.009.002'; 
    isAccessGranted = false;
    DistrictList: District[] = [];
    currDistrict: District | null = {code: '', name: ''};
    currYear: Year | null = null; 
    yearList: Year[] = [];
    directionList: Direction[] = [];
    downloadingItems: string[] = [];
    

    async created() {
        await this.getObl(); 
        await this.get_district_data_by_ate(this.$i18n.locale);
        await this.get_direction_data(this.$i18n.locale);
        await this.get_srs_report_access_permissions(this.$i18n.locale);
        this.generateYearList();
    }


    @Watch('$i18n.locale', { immediate: true })
    async onLocaleChange(newLocale: string, oldLocale: string) {
        if (!newLocale || newLocale.trim() === '' || !this.obl.code) {
            return;
        }
        await this.get_district_data_by_ate(newLocale);
        await this.get_direction_data(newLocale);
    }

    onClickReset() {
        this.currYear = this.yearList[this.yearList.length - 1];
        this.currDistrict = null;
    }

    onClickApply() {
        if (!this.currYear) {
            this.makeToast(
                'warning', 
                String(this.$t('modules.srs.warnings.year_not_selected')), 
                String(this.$t('modules.srs.warnings.warning'))
            );
            return;
        }
        if (!this.currDistrict) {
            this.makeToast(
                'warning', 
                String(this.$t('modules.srs.warnings.district_not_selected')), 
                String(this.$t('modules.srs.warnings.warning'))
            );
            return;
        }

        this.$refs.drop.hide(true);
    }

    getNormalizedLocale(locale=this.$i18n.locale): string {
        return (locale === 'kk' || locale === 'kz') ? 'kz' : 'ru';
    }
    
    async getObl(): Promise<void> {
        try {
            const response = await fetch(`/api-py/get-budget-obl/${this.$store.state._instanceCode}`)
            this.obl = await response.json();
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.get_obl_error')), 
                err.message || err.toString()
            );
        }
    }

    async get_srs_report_access_permissions(locale: string): Promise<void> {
        try {
            const userData = { 
                userId: this.$store.getters.user_uuid,
                moduleCode: this.moduleCode 
            };

            const response = await fetch(`/api-py/srs/report/access/${this.obl.code}?lang=${locale}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            }); 

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            this.isAccessGranted = await response.json();
            // Emit the event to parent with the data
            this.$emit('access-permissions', this.isAccessGranted);

        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.get_srs_report_access_permissions_error')), 
                err.message || err.toString()
            );
        }
    }


    async get_district_data_by_ate(locale: string): Promise<void> {
        try {
            const userData = { 
              userId: this.$store.getters.user_uuid,
              moduleCode: this.moduleCode 
            };

            const ateCode = '0';
            const response = await fetch(`/api-py/srs/district/${this.obl.code}?ate=${ateCode}&lang=${locale}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            }); 

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            this.DistrictList = await response.json();
            this.currDistrict = null; 
    
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.district_error')), 
                err.message || err.toString()
            );
        }
    }

    async get_direction_data(locale: string): Promise<void> {
        try {
            const response = await fetch(`/api-py/srs/direction?lang=${locale}`);
            this.directionList = await response.json();

        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.direction_error')),
                err.message || err.toString()
            );
        }
    }

    async showDownloadError(response: Response): Promise<void> {
        console.error(`SRS report download failed, status: ${response.status}`);
        if (response.status === 404) {
            this.makeToast(
                'warning',
                String(this.$t('modules.srs.warnings.report_no_data')),
                String(this.$t('modules.srs.warnings.warning'))
            );
        } else {
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.report_generate_error')),
                String(this.$t('modules.srs.warnings.error'))
            );
        }
    }

    async downloadReport(dir: Direction): Promise<void> {
    
        try {
            if (!this.currYear) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.year_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }
            if (!this.currDistrict) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.district_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }

            // Prevent multiple clicks on same item
            if (this.downloadingItems.includes(dir.code)) {
                return;
            }

            this.onClickDownloadReport(); 
            // Add to downloading list
            this.downloadingItems.push(dir.code);
            const response = await fetch(`/api-py/srs/report/download/${this.obl.code}?year=${this.currYear.year}&distCode=${this.currDistrict?.code}&dirCode=${dir.code}&lang=${this.$i18n.locale}`);

            if (!response.ok) {
                await this.showDownloadError(response);
                return;
            }

            const dirName  = dir.name.split(' ').join('_');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.currYear.year}_CРС_${dir.code}_${dirName}.xlsx`;
            link.style.display = 'none';
            link.click();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            const err = error as Error;
            console.error('SRS report download error:', err.message || err);
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.report_generate_error')),
                String(this.$t('modules.srs.warnings.error'))
            );
        }   finally {
            const index = this.downloadingItems.indexOf(dir.code);
            if (index > -1) {
                this.downloadingItems.splice(index, 1);
            }
        }
    }


    async downloadReportAll() {
        try {
            if (!this.currYear) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.year_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }
            if (!this.currDistrict) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.district_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }

            // Prevent multiple clicks on same item
            if (this.downloadingItems.includes('13')) {
                return;
            }

            this.onClickDownloadReport();
            // Add to downloading list; '13' - summary
            this.downloadingItems.push('13');
            const response = await fetch(`/api-py/srs/report/download/all/${this.obl.code}?year=${this.currYear.year}&distCode=${this.currDistrict?.code}&lang=${this.$i18n.locale}`);

            if (!response.ok) {
                await this.showDownloadError(response);
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.currYear.year}_CРС_${this.$t("modules.srs.report.summary_download")}.xlsx`;
            link.style.display = 'none';
            link.click();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            const err = error as Error;
            console.error('SRS report download error:', err.message || err);
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.report_generate_error')),
                String(this.$t('modules.srs.warnings.error'))
            );
        } finally {
            const index = this.downloadingItems.indexOf('13');
            if (index > -1) {
                this.downloadingItems.splice(index, 1);
            }
        }
    }


    async downloadReportAteAll() {
        try {
            if (!this.currYear) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.year_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }
            if (!this.currDistrict) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.district_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }
            // Prevent multiple clicks on same item
            if (this.downloadingItems.includes('14')) {
                return;
            }

            this.onClickDownloadReport();
            // Add to downloading list; '14' - summary by ate
            this.downloadingItems.push('14');
            const response = await fetch(`/api-py/srs/report/download/ate/all/${this.obl.code}?year=${this.currYear.year}&distCode=${this.currDistrict?.code}&lang=${this.$i18n.locale}&repType=1`);

            if (!response.ok) {
                await this.showDownloadError(response);
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            const fileName = String(this.$t("modules.srs.report.summary_ate")).split(' ').join('_');
            link.href = url;
            link.download = `${this.currYear.year}_${fileName}.xlsx`;
            link.style.display = 'none';
            link.click();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            const err = error as Error;
            console.error('SRS report download error:', err.message || err);
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.report_generate_error')),
                String(this.$t('modules.srs.warnings.error'))
            );
        } finally {
            const index = this.downloadingItems.indexOf('14');
            if (index > -1) {
                this.downloadingItems.splice(index, 1);
            }
        }
    }


    async downloadByDirectionZipFile() {
        try {
            if (!this.currYear) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.year_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }
            if (!this.currDistrict) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.district_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }

            if (this.downloadingItems.includes('15')) {
                return;
            }

            this.onClickDownloadReport();
            this.downloadingItems.push('15');
            const response = await fetch(`/api-py/srs/report/download/zip/${this.obl.code}?year=${this.currYear.year}&distCode=${this.currDistrict?.code}&lang=${this.$i18n.locale}`);

            if (!response.ok) {
                await this.showDownloadError(response);
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.$t("modules.srs.report.zip_file_name")}.zip`; 
            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            const err = error as Error;
            console.error('SRS report download error:', err.message || err);
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.report_generate_error')),
                String(this.$t('modules.srs.warnings.error'))
            );
        } finally {
            const index = this.downloadingItems.indexOf('15');
            if (index > -1) {
                this.downloadingItems.splice(index, 1);
            }
        }
    }

    // отчет СРС_Общий_СВОД
    async downloadSummaryReportByAte() {
        try {
            if (!this.currYear) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.year_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }
            if (!this.currDistrict) {
                this.makeToast(
                    'warning', 
                    String(this.$t('modules.srs.warnings.district_not_selected')), 
                    String(this.$t('modules.srs.warnings.warning'))
                );
                return;
            }
            // Prevent multiple clicks on same item
            if (this.downloadingItems.includes('16')) {
                return;
            }

            this.onClickDownloadReport();
            this.downloadingItems.push('16');
            const response = await fetch(`/api-py/srs/report/download/ate/all/${this.obl.code}?year=${this.currYear.year}&distCode=${this.currDistrict?.code}&lang=${this.$i18n.locale}&repType=2`);

            if (!response.ok) {
                await this.showDownloadError(response);
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            const year = this.currYear.year; 
            const fileName = String(this.$t("modules.srs.report.srs_summary_report_year", {"year": year}));
            link.href = url;
            link.download = `${fileName}.xlsx`;
            link.style.display = 'none';
            link.click();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            const err = error as Error;
            console.error('SRS report download error:', err.message || err);
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.report_generate_error')),
                String(this.$t('modules.srs.warnings.error'))
            );
        } finally {
            const index = this.downloadingItems.indexOf('16');
            if (index > -1) {
                this.downloadingItems.splice(index, 1);
            }
        }
    }


    onClickDownloadReport() {
        this.makeToast(
            'success',
            this.$t('modules.srs.report.download_started').toString(),
            String(this.$t('modules.srs.warnings.information'))
        );       
    }


    generateYearList(): Year[] {
        const startYear = 2024;
        const currentYear = new Date().getFullYear()-1;

        for (let year = startYear; year <= currentYear; year++) {
            const index = year - startYear + 1;
            const obj: Year = { 
                id: index, 
                year: year 
            };
            this.yearList.push(obj);
        }
        this.currYear = this.yearList[this.yearList.length - 1];
        return this.yearList;
    }


    openFilterByRef(refName: string) {
        const drop = this.$refs.drop;
        drop.show(true);
        this.$emit('openFilterByRef', refName);
        let refItem: any;
        switch (refName) {
            case 'year':
                refItem = this.$refs.year;
                break;
            case 'district':
                refItem = this.$refs.district;
                break;
            default:
                break;
        }
        setTimeout(() => refItem.$el.focus(), 100);
    }

    makeToast(variant: string, toastBody: string, title: string): void {
        (this as any).$bvToast.toast(toastBody, {
            title: title,
            variant: variant,
            autoHideDelay: 3000,
            solid: true
        });
    }


}

